document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("gb-manual-form");
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Collect up to 4 product IDs
    const ids = [
      document.getElementById("gb-product-id-1").value.trim(),
      document.getElementById("gb-product-id-2").value.trim(),
      document.getElementById("gb-product-id-3").value.trim(),
      document.getElementById("gb-product-id-4").value.trim(),
    ].filter(Boolean);

    if (ids.length === 0) {
      alert("Please enter at least one product ID.");
      return;
    }

    try {
      const items = ids.map(id => ({ productId: id }));
      const data = await fetchSpecsFromAPI(items);

      if (Object.keys(data).length > 0) {
        renderComparisonTable(data);
      } else {
        alert("No specs found for the entered IDs.");
      }
    } catch (err) {
      console.error("Error fetching product specs:", err);
      alert("Failed to fetch product specs.");
    }
  });
});

// Fetch from Vercel API //
async function fetchSpecsFromAPI(items) {
  try {
    const res = await fetch("https://gb-variant-comparison.vercel.app/api/get-product-specs-metafields", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      console.error("API error:", res.status);
      return {};
    }

    const apiData = await res.json();
    const formatted = {};

    (apiData.results || []).forEach(item => {
      if (item?.error) return;

      const parsedSpecs = item.comparison_specs ? JSON.parse(item.comparison_specs) : {};
      const key = String(item.originalId || item.productId);

      formatted[key] = {
        gid: item.productId,
        title: item.productTitle || "(Untitled Product)",
        handle: item.handle || null,
        productUrl: item.handle ? `https://gibbyselectronicsupermarket.ca/products/${item.handle}` : null,
        image: item.image || null,
        specs: parsedSpecs
      };
    });

    return formatted;
  } catch (e) {
    console.error("Exception during fetchSpecsFromAPI:", e);
    return {};
  }
}

// --- Formatting helpers --- //
function formatLabel(str) {
  if (!str) return "";
  return str.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

// --- Render comparison table (same as original) --- //
function renderComparisonTable(data) {
  const entries = Object.entries(data);

  const allSections = [];
  const seenSections = new Set();
  entries.forEach(([, product]) => {
    Object.keys(product.specs || {}).forEach(sectionKey => {
      if (!seenSections.has(sectionKey)) {
        allSections.push(sectionKey);
        seenSections.add(sectionKey);
      }
    });
  });

  let html = "<colgroup><col class='gb-feature-col'>";
  entries.forEach(() => (html += "<col class='gb-product-col'>"));
  html += "</colgroup><thead>";

  // Images
  html += "<tr class='gb-compare-table-img-row'><th></th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.image ? `<img src="${p.image}" style="max-width: 200px" class="gb-comparison-image">` : ""}</th>`;
  });
  html += "</tr>";

  // Titles
  html += "<tr><th>Feature</th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.title}</th>`;
  });
  html += "</tr>";

  html += "</thead><tbody>";

  // Body rows
  allSections.forEach(sectionKey => {
    let isNested = false;
    entries.forEach(([, p]) => {
      const val = p.specs?.[sectionKey];
      if (typeof val === "object" && val !== null) isNested = true;
    });

    if (isNested) {
      html += `<tr class="gb-subheading-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(() => { html += `<td></td>`; });
      html += `</tr>`;

      const subKeys = [];
      const seenSubKeys = new Set();
      entries.forEach(([, p]) => {
        const val = p.specs?.[sectionKey];
        if (typeof val === "object" && val) {
          Object.keys(val).forEach(subKey => {
            if (!seenSubKeys.has(subKey)) {
              subKeys.push(subKey);
              seenSubKeys.add(subKey);
            }
          });
        }
      });

      subKeys.forEach(subKey => {
        html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
        entries.forEach(([, p]) => {
          const value = p.specs?.[sectionKey]?.[subKey] ?? "-";
          html += `<td>${value}</td>`;
        });
        html += `</tr>`;
      });

    } else {
      html += `<tr class="gb-normal-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(([, p]) => {
        const value = p.specs?.[sectionKey] ?? "-";
        html += `<td>${value}</td>`;
      });
      html += `</tr>`;
    }
  });

  const table = document.getElementById("gb-comparison-table");
  if (!table) return;
  table.innerHTML = html;
}
